import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import { Button, Modal, Spin, Table } from "antd";

import ModalComponent from "../../../components/modalComponent/ModalComponent";
import { fetchPremiumList } from "../../../redux/actions/premiumActions";
import PremiumFilters from "./PremiumFilters";
import PremiumForm from "./Premium.form";
import { columns } from "./Premium.utils";
import PremiumModal from "./PremiumModal";

import { validateBonus, rejectBonus, deleteBonuses } from "../../../modules/presence/api/api";
import { selectUserRoleId } from "../../../redux/selectors/user";
import { BONUS_TYPE_ID, FREQUENCY_ID } from "../../../configs/constants";
import { handleError } from "../../../modules/presence/sagas";

const Bonuses = ({ getBonusesList, premiumList = [], token, roleId }) => {
  const [selectedClient, setSelectedClient] = useState();
  const [premiumsToDeleteId, setPremiumsToDeleteId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState();
  const [selectedUser, setSelectedUser] = useState();
  const [premiumSelected, setPremiumSelected] = useState(null);
  const [isTreatedFormOpen, setIsTreatedFormOpen] = useState(false);
  const [isUpdatedFormOpen, setIsUpdatedFormOpen] = useState(false);

  const [rangeDate, setRangeDate] = useState([
    moment()
      .add(-1, "month")
      .startOf("month"),
    moment()
      .add(-1, "month")
      .endOf("month")
  ]);

  const [numberToDelete, setNumberToDelete] = useState(-1);

  const resetSelectedPremiums = () => {
    setNumberToDelete(-1);
    setPremiumsToDeleteId(null);
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      if (!selectedRows || isEmpty(selectedRows)) {
        resetSelectedPremiums();
      } else {
        setNumberToDelete(selectedRows.length);
        setPremiumsToDeleteId(selectedRows.map(item => item._id));
      }
    }
  };

  const getMatchParams = {
    type_id: BONUS_TYPE_ID.EXTRA,
    $or: [
      {
        $and: [
          { start_date: { $gte: { $date: rangeDate[0] }, $lte: { $date: rangeDate[1] } } },
          { frequency_id: FREQUENCY_ID.MONTHLY }
        ]
      },
      {
        $and: [
          {
            start_date: {
              $gte: { $date: moment(rangeDate[0]).startOf("quarter") },
              $lte: { $date: moment(rangeDate[1]).endOf("quarter") }
            }
          },
          { frequency_id: FREQUENCY_ID.QUARTERLY }
        ]
      }
    ],
    ["clients.label"]: selectedClient
  };
  const fetchPremiums = useCallback(
    params => {
      if (!params) {
        params = {
          match: {
            $or: [
              {
                $and: [
                  { start_date: { $gte: { $date: rangeDate[0] }, $lte: { $date: rangeDate[1] } } },
                  { frequency_id: FREQUENCY_ID.MONTHLY }
                ]
              },
              {
                $and: [
                  {
                    start_date: {
                      $gte: { $date: moment(rangeDate[0]).startOf("quarter") },
                      $lte: { $date: moment(rangeDate[1]).endOf("quarter") }
                    }
                  },
                  { frequency_id: FREQUENCY_ID.QUARTERLY }
                ]
              }
            ]
          }
        };
      }
      getBonusesList({ ...params, sort: { created_at: -1 } });
    },
    [rangeDate]
  );

  useEffect(() => {
    fetchPremiums({
      match: getMatchParams
    });
  }, [selectedClient, rangeDate]);

  const getDataSource = () => {
    return premiumList.filter(
      premium =>
        (!selectedUser || selectedUser === premium.user_fullname) &&
        premium.status &&
        (!selectedStatus || selectedStatus === premium.status.label)
    );
  };

  const onClickHandlePremium = premiumId => {
    setPremiumSelected(premiumList.find(item => item._id === premiumId));
    setIsTreatedFormOpen(true);
  };

  const onClickUpdatePremium = premiumId => {
    setPremiumSelected(premiumList.find(item => item._id === premiumId));
    setIsUpdatedFormOpen(true);
  };

  const handleOnClickValidateReject = async (premiumId, premiumAction, comment) => {
    try {
      if (premiumAction === "validate")
        await validateBonus(
          {
            _id: premiumId
          },
          token
        );
      else
        await rejectBonus(
          {
            _id: premiumId,
            rejected_infos: {
              comment
            }
          },
          token
        );

      const params = {
        match: { ...getMatchParams }
      };
      if (selectedClient) params.match["clients.label"] = selectedClient;
      fetchPremiums(params);
      setPremiumSelected(null);
      setIsTreatedFormOpen(false);
    } catch (e) {
      console.log("e", e, e.response);
    }
  };

  const handledeleteBonuses = async () => {
    try {
      await deleteBonuses(
        {
          _ids: premiumsToDeleteId
        },
        token
      );

      resetSelectedPremiums();
      fetchPremiums();
    } catch (e) {
      handleError(e);
    }
  };

  return (
    <div className="w-full">
      <div className="flex justify-between mb-5 items-center">
        <div className="flex items-center">
          <div className="text-3xl font-bold text-gray-900">Primes exceptionnelles</div>
        </div>

        {/* <Help />

        <div className="mr-10">
          <div className="mr-10 mb-10">
            <div
              className="cursor-pointer px-6 py-2 leading-5 rounded-full bg-red-600 text-white"
              onClick={() => {
                setIsCreateFormOpen(true);
                setSelectedIdTypeForForm(BONUS_TYPE_ID.REGULAR);
              }}
            >
              Ajouter une prime normale
            </div>
          </div>
          <div
            className="cursor-pointer px-6 py-2 leading-5 rounded-full bg-red-600 text-white"
            onClick={() => {
              setIsCreateFormOpen(true);
              setSelectedIdTypeForForm(BONUS_TYPE_ID.EXTRA);
            }}
          >
            Ajouter une prime exceptionnelle
          </div>
        </div> */}
      </div>
      <PremiumFilters
        setSelectedClient={setSelectedClient}
        selectedClient={selectedClient}
        fetchPremiums={fetchPremiums}
        token={token}
        handledeleteBonuses={handledeleteBonuses}
        setSelectedUser={setSelectedUser}
        setSelectedStatus={setSelectedStatus}
        numberToDelete={numberToDelete}
        rangeDate={rangeDate}
        setRangeDate={setRangeDate}
        selectedUser={selectedUser}
        data={premiumList}
      />
      <Table
        rowSelection={{
          // type: selectionType,
          ...rowSelection
        }}
        columns={columns(onClickUpdatePremium, onClickHandlePremium, premiumList, roleId)}
        dataSource={getDataSource()}
      />
      {/* <ModalComponent
        title={`Ajout d'une prime ${selectedTypeIdForForm === BONUS_TYPE_ID.REGULAR ? "normale" : "exceptionnelle"}`}
        width={500}
        showModal={isCreateFormOpen}
        closeModal={() => setIsCreateFormOpen(false)}
      >
        <PremiumForm
          getMatchParams={getMatchParams}
          selectedClient={selectedClient}
          action="create"
          fetchPremiums={fetchPremiums}
          closeModal={() => setIsCreateFormOpen(false)}
          selectedTypeId={selectedTypeIdForForm}
        />
      </ModalComponent> */}
      <ModalComponent
        title={`Traiter une prime`}
        width={500}
        showModal={isTreatedFormOpen}
        closeModal={() => setIsTreatedFormOpen(false)}
      >
        <PremiumModal
          premium={premiumSelected}
          handleOnClickValidateReject={handleOnClickValidateReject}
          isModalVisible={isTreatedFormOpen}
        />
      </ModalComponent>
      <ModalComponent
        title={`Modifier une prime`}
        width={500}
        showModal={isUpdatedFormOpen}
        closeModal={() => setIsUpdatedFormOpen(false)}
      >
        <PremiumForm
          getMatchParams={getMatchParams}
          selectedClient={selectedClient}
          action="update"
          premiumSelected={premiumSelected}
          fetchPremiums={fetchPremiums}
          closeModal={() => setIsUpdatedFormOpen(false)}
        />
      </ModalComponent>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    premiumList: state.premium.premiumList,
    token: state.auth.token,
    roleId: selectUserRoleId(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getBonusesList: payload => dispatch(fetchPremiumList(payload))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Bonuses);



// WEBPACK FOOTER //
// src/containers/admin/premium/Bonuses.js